export default {
  CREATE: `Create a wage premium`,
  DELETE_BUTTON: {
    TITLE: `Delete the wage premium`,
    SUMMARY: `Are you sure you want to delete this wage premium?`,
    PRIMARY_ACTION: `Delete the wage premium`
  },
  LIST: {
    TITLE: `Wage premium list`,
    SUMMARY: ``
  },
  OVERTIME: `Overtime`,
  EARNINGCODE: `Earning code`,
  HASHOURMULTIPLIER: `Has hour multiplier`,
  HOURMULTIPLIER: `Hour multiplier`,
  HOURSAPPLIEDTO: `Hours applied to`,
  DEFAULTPREDETERMINEDHOURS: `Default pre-determined hours`,
  DEDUCTFROMREGULARHOURS: `Deducted from regular hours`,
  COUNTASOVERTIME: `Counts as overtime`,
  form: {
    CREATE: {
      TITLE: `Creating a wage premium`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Editing a wage premium`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Name`,
      DESCRIPTION: `This name should help you quickly identify the wage premium.`,
      PLACEHOLDER: `Enter a name for the wage premium`
    },
    EARNINGCODE: {
      LABEL: `Earning code`,
      DESCRIPTION: `This code will be used to export information to external pay systems and should also be defined in those systems.`,
      PLACEHOLDER: `Enter the earning code`
    },
    ASSIGNBASEDONATTRIBUTESENABLED: {
      LABEL: `Assign based on attributes`,
      DESCRIPTION: `Automatically assign this wage premium to punch cards based on employee or position attributes.`
    },
    DEDUCTFROMREGULARHOURS: {
      LABEL: `Deduct from regular hours`,
      DESCRIPTION: `Hours associated to this wage premium will be subtracted from the regular earnings code (G1).`
    },
    COUNTASOVERTIME: {
      LABEL: `Count as overtime`,
      DESCRIPTION: `Hours associated to this wage premium will be considered when calculating overtime per period.`
    },
    HASHOURMULTIPLIER: {
      LABEL: `Has hour multiplier`,
      DESCRIPTION: `Hours will be scaled by the multiplier.`
    },
    HOURMULTIPLIER: {
      LABEL: `Hour multiplier`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Scaling factor to use.`
    },
    HASPAYRATE: {
      LABEL: `Has pay rate`,
      DESCRIPTION: `Used to add wage premiums to schedule cost reporting.`
    },
    PAYRATETYPE: {
      LABEL: `Pay rate type`,
      DESCRIPTION: ``,
      REGULAR: `Employee regular rate`,
      OVERTIME: `Employee overtime rate`,
      CUSTOM: `Custom rate`
    },
    PAYRATE: {
      LABEL: `Custom pay rate`,
      DESCRIPTION: ``
    },
    HOURSAPPLIEDTO: {
      LABEL: `Applied to`,
      DESCRIPTION: ``,
      UNITS: `units`,
      OPTIONS: {
        FULL_SHIFT: {
          LABEL: `Apply to the entire shift`,
          DESCRIPTION: `The value retained for this wage premium will be the length of the entire shift.`
        },
        PRE_DETERMINED: {
          LABEL: `Pre-determined amount`,
          DESCRIPTION: `The value retained for this wage premium will be the same regardless of shift length.`
        },
        UNIT_BASED: {
          LABEL: `Unit-based amount`,
          DESCRIPTION: `The value retained for this wage premium is measured in a unit other than hours. (ie. mileage)`
        }
      }
    },
    ASSIGNBASEDONATTRIBUTESRULE: {
      LABEL: ``,
      DESCRIPTION: ``,
      OPTIONS: {
        userHasAttribute: {
          LABEL: `Assign if the employee has required attributes`,
          DESCRIPTION: ` `
        },
        attributeRequired: {
          LABEL: `Assign if the shift requires attributes`,
          DESCRIPTION: ` `
        },
        attributeRequiredAndUserHasAttribute: {
          LABEL: `Assign if there is a match between the required attributes of the shift and the employee's attributes.`,
          DESCRIPTION: ` `
        }
      }
    },
    ASSIGNBASEDONFOLLOWINGATTRIBUTES: {
      LABEL: '',
      DESCRIPTION: ``
    },
    DEFAULTUNITARYAMOUNT: {
      LABEL: `Pre-determined amount`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Value this this wage premium will be applied to by default, this can be changed on a shift by shift basis.`
    },
    UNITARYAMOUNTTYPE: {
      LABEL: `Unit type`,
      PLACEHOLDER: `Enter a unit type`,
      DESCRIPTION: `Visual cue for users to know what type of unit to enter (ie. km for kilometers). `
    },
    DEFAULTPREDETERMINEDHOURS: {
      LABEL: `Pre-determined amount`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Number of hours this wage premium will be applied to, can be changed on a shift by shift basis.`
    },
    ASSIGNBASEDONRANGEENABLED: {
      LABEL: 'Assign based on time ranges',
      DESCRIPTION: 'Automatically assign this wage premium to punch cards within a specified range'
    },
    NAME_REQUIRED: `Name is mandatory.`,
    EARNING_CODE_REQUIRED: `Earning code is mandatory.`,
    DAYS_REQUIRED: `Day(s) is mandatory`,
    START_TIME_REQUIRED: `Start time is mandatory`,
    END_TIME_REQUIRED: `End time is mandatory`,
    START_DAY_REQUIRED: `Start day is mandatory`,
    END_DAY_REQUIRED: `End day is mandatory`,
    ADD_RANGE: `Add another range`,
    FROM: `From`,
    TO: `To`,
    DAY: `Day`,
    HOUR: `Hour`,
    SELECT: `Select`,
    ALL_DAYS: `All days`,
    MIN_ONE_RANGE: `At least one range is required`,
    MIN_ONE_ATTRIBUTE: `At least one attribute is required.`,
    SEARCH_ATTRIBUTES: `Search attributes`,
    GREATER_THAN_ZERO: `Must be greater than 0`
  }
}
